/**
 * ## Chart component
 *
 * @module src/components/chart
 */

"use strict";

const conf = require("../../config");
const loc = require("../../controllers/location");
const icons = require("../../components/icons");
const notification = require("../notification");
const tables = require("./tables");
const func = require("../../controllers/func");
const moment = require("moment-timezone");

const iconSize = 128;
let activity_id = null;
let target_id = null;
let scale = 1;
let pinchScale = 1;
let location;
let chart;
let reservations;
let template;
let liveTables = [];
let lockTables = [];
let lockTablesWait = [];
let $panzoom;
let active = true;
let bounds = {};
let activityInterval;
let highlight = {
  active: false,
  tables: [],
};
const multiSelect = {
  active: false,
  tables: [],
};

const selectionBounds = {
  active: false,
  start: {
    x: 0,
    y: 0,
  },
  end: {
    x: 0,
    y: 0,
  },
  move: {
    x: 0,
    y: 0,
  },
};

const embedOverflow = {
  active: false,
  count: 0,
  tables: [],
};

let preSelect = {
  active: false,
  count: 0,
  tables: [],
};

const getScale = () => {
  return scale;
};

const getTurnTime = () => {
  return location.baseTurn;
};

const getEmbedOverflow = () => {
  return embedOverflow;
};

const setEmbedOverflow = (bool, count) => {
  if (!bool) {
    embedOverflow.tables = [];
  }
  embedOverflow.active = bool;
  embedOverflow.count = count;
};

const addEmbedOverflow = (table) => {
  embedOverflow.tables.push(table);
};

const room = (kd, roomnum) => {
  kd.localstore.data.room = roomnum;
  $("#layout_chart_rooms_select > .layout_chart_rooms_select_item").removeClass(
    "layout_chart_rooms_select_item_highlight"
  );
  $(`#room_select${roomnum}`).addClass(
    "layout_chart_rooms_select_item_highlight"
  );
  $("#layout_chart_main > .table_lib").css("display", "none");
  $(`#layout_chart_main > .table_lib[data-room="${roomnum}"]`).css(
    "display",
    "block"
  );
};

const getRoomByTable = (table) => {
  for (let i = 0; i < chart.tables.length; ++i) {
    if (chart.tables[i].table == table) {
      return chart.tables[i].room;
    }
  }
};

const roomBySection = (kd, section) => {
  for (let i = 0; i < template.tables.length; ++i) {
    if (template.tables[i].section == section) {
      for (let t = 0; t < chart.tables.length; ++t) {
        if (template.tables[i].table == chart.tables[t].table) {
          room(kd, chart.tables[t].room);
          break;
        }
      }
      break;
    }
  }
};

const roomByTable = (kd, table) => {
  for (let t = 0; t < chart.tables.length; ++t) {
    if (table == chart.tables[t].table) {
      room(kd, chart.tables[t].room);
      break;
    }
  }
};

const setScale = () => {
  const element = document.querySelector("#layout_chart_main");
  scale = element.getBoundingClientRect().width / element.offsetWidth;
  return scale;
};

const getActive = () => {
  return active;
};

const isDisabled = (kd, table) => {
  if (kd.location.disabledTables.includes(table)) {
    return 1;
  }
  return 0;
};

const selection = (kd, opt, callback) => {
  switch (opt.type) {
    case "start": {
      $("#selection").css("visibility", "hidden");
      selectionBounds.active = true;
      selectionBounds.start.x = opt.x;
      selectionBounds.start.y = opt.y;
      selectionBounds.end.x = opt.x;
      selectionBounds.end.y = opt.y;
      TweenMax.to("#selection", 0, {
        x: selectionBounds.start.x,
        y: selectionBounds.start.y,
        width: 0,
        height: 0,
      });
      break;
    }
    case "end": {
      $("#selection").css("visibility", "hidden");
      selectionBounds.active = false;
      selectionBounds.end.x = opt.x;
      selectionBounds.end.y = opt.y;
      // get all tables and return ids
      const loc2 = kd.doc("location")[0];
      const chartID = loc2.chart;
      const tablesdata = kd.doc("chart", chartID)[0].tables;
      const select = {
        offset: {
          x: $("#layout_chart_main").offset().left,
          y: $("#layout_chart_main").offset().top,
        },
        topLeft: {
          x: $("#selection").offset().left,
          y: $("#selection").offset().top,
        },
        bottomRight: {
          x: $("#selection").offset().left + $("#selection").width(),
          y: $("#selection").offset().top + $("#selection").height(),
        },
      };
      const tables2 = [];
      if (
        selectionBounds.start.x !== selectionBounds.end.x &&
        selectionBounds.start.x !== 0
      ) {
        for (let t = 0; t < tablesdata.length; ++t) {
          if (
            kd.localstore.data.room === tablesdata[t].room &&
            select.offset.x + (tablesdata[t].x + 64) * scale >
              select.topLeft.x &&
            select.offset.y + (tablesdata[t].y + 64) * scale >
              select.topLeft.y &&
            select.offset.x + (tablesdata[t].x + 64) * scale <
              select.bottomRight.x &&
            select.offset.y + (tablesdata[t].y + 64) * scale <
              select.bottomRight.y
          ) {
            tables2.push(tablesdata[t]);
          }
        }
      }
      callback(null, tables2);
      break;
    }
    case "move": {
      if (selectionBounds.active) {
        selectionBounds.move.x = opt.x;
        selectionBounds.move.y = opt.y;
        if (
          selectionBounds.move.x - selectionBounds.start.x < 0 &&
          selectionBounds.move.y - selectionBounds.start.y > 0
        ) {
          TweenMax.to("#selection", 0, {
            x: selectionBounds.move.x,
            width: selectionBounds.start.x - selectionBounds.move.x,
            height: selectionBounds.move.y - selectionBounds.start.y,
          });
        } else if (
          selectionBounds.move.x - selectionBounds.start.x > 0 &&
          selectionBounds.move.y - selectionBounds.start.y > 0
        ) {
          TweenMax.to("#selection", 0, {
            width: selectionBounds.move.x - selectionBounds.start.x,
            height: selectionBounds.move.y - selectionBounds.start.y,
          });
        } else if (
          selectionBounds.move.x - selectionBounds.start.x < 0 &&
          selectionBounds.move.y - selectionBounds.start.y < 0
        ) {
          TweenMax.to("#selection", 0, {
            x: selectionBounds.move.x,
            y: selectionBounds.move.y,
            width: selectionBounds.start.x - selectionBounds.move.x,
            height: selectionBounds.start.y - selectionBounds.move.y,
          });
        } else if (
          selectionBounds.start.x - selectionBounds.move.x < 0 &&
          selectionBounds.start.y - selectionBounds.move.y > 0
        ) {
          TweenMax.to("#selection", 0, {
            y: selectionBounds.move.y,
            width: selectionBounds.move.x - selectionBounds.start.x,
            height: selectionBounds.start.y - selectionBounds.move.y,
          });
        }
        $("#selection").css("visibility", "visible");
      }
      break;
    }
    default: {
      break;
    }
  }
};
const setActivityInterval = (kd, callback) => {
  clearInterval(activityInterval);
  activityInterval = setInterval(() => {
    reset(kd, { all: false }, (err, obj) => {
      callback(err, obj);
    });
  }, 60000);
};

const reset = (kd, change, callback) => {
  // detect if in altTables mode and set altTables controls.
  if (kd.location.hasOwnProperty("altTables") && kd.location.altTables) {
    $("#layout_alt_tables_live").css("visibility", "visible");
  } else {
    $("#layout_alt_tables_live").css("visibility", "hidden");
  }
  if (conf.vars.NODE_ENV.indexOf("ios") > -1) {
    $("#layout_chart_header_4top_drop").css("padding-top", "17px");
  }

  for (let i = 0; i < conf.vars.turnTimes.length; ++i) {
    if (conf.vars.turnTimes[i].value === kd.location.baseTurn) {
      $("#layout_chart_header_4top_drop")
        .html(`${conf.vars.turnTimes[i].description} \
            ${icons.lib.down}`);
      break;
    }
  }

  renderTables(kd, change, callback);

  bounds = getBounds();

  // let down_offset = 0;
  // let up_offset = 0;
  let coords = {
    down: false,
    moved: false,
    x: 0,
    y: 0,
  };
  if (change.hasOwnProperty("all") && change.all) {
    // set turntime display
    if (kd.localstore.data.op_state === "chart") {
      let down_offset = 0;
      let up_offset = 0;
      $(".top").off();
      $(".top").on("mousedown touchstart", (event) => {
        event.preventDefault();
        if (!active) {
          event.stopPropagation();
        }
        // this would work on desktop and mobile devices at the same time })
        activity_id = $(event.target).parents(".table_lib").data("id");
        target_id = $(event.target).parents(".table_lib").attr("id");
        const mouseXPos =
          $(event.target).parents(".table_lib").offset().left - 64;
        const mouseYPos =
          $(event.target).parents(".table_lib").offset().top - 64;
        down_offset = $(`#${target_id}`).offset();
        const this_obj = {
          target_id,
          activity_id,
          id: $(`#${target_id}`).data("index"),
          table: $(`#${target_id}`).data("table"),
          action: "down",
          disabled: $(`#${target_id}`).data("disabled"),
          source: $(`#${target_id}`).data("source"),
          type: $(`#${target_id}`).data("type"),
          seat: $(`#${target_id}`).data("seat"),
          multiSelect,
          mouseXPos,
          mouseYPos,
        };
        callback(null, this_obj);
      });

      $(".top").on("mouseup touchend", (event) => {
        event.preventDefault();
        if (!active) {
          event.stopPropagation();
        }
        activity_id = $(event.target).parents(".table_lib").data("id");
        target_id = $(event.target).parents(".table_lib").attr("id");
        up_offset = $(`#${target_id}`).offset();
        let action = "drag";
        if (kd.localstore.data.op_state !== "chart") {
          if (
            Math.abs(up_offset.left - down_offset.left) < 15 &&
            Math.abs(up_offset.top - down_offset.top) < 15
          ) {
            action = "up";
          }
        } else {
          if (
            Math.abs(up_offset.left - down_offset.left) < 1 &&
            Math.abs(up_offset.top - down_offset.top) < 1
          ) {
            action = "up";
          }
        }
        const this_obj = {
          target_id,
          activity_id,
          id: $(`#${target_id}`).data("index"),
          table: $(`#${target_id}`).data("table"),
          action,
          disabled: $(`#${target_id}`).data("disabled"),
          source: $(`#${target_id}`).data("source"),
          type: $(`#${target_id}`).data("type"),
          seat: $(`#${target_id}`).data("seat"),
          multiSelect,
        };
        callback(null, this_obj);
      });
    }

    if (kd.localstore.data.op_state === "chart") {
      // kd.localstore.data.op_state === 'inline'
      $(document).off("keydown");
      $(document).on("keydown", (event) => {
        const this_obj = {
          target_id,
          id: $(`#${target_id}`).data("index"),
          source: $(`#${target_id}`).data("source"),
          type: $(`#${target_id}`).data("type"),
          seat: $(`#${target_id}`).data("seat"),
          multiSelect,
        };
        switch (event.keyCode) {
          case 38: {
            this_obj.action = "pixelUp";
            callback(null, this_obj);
            break;
          }
          case 39: {
            this_obj.action = "pixelRight";
            callback(null, this_obj);
            break;
          }
          case 37: {
            this_obj.action = "pixelLeft";
            callback(null, this_obj);
            break;
          }
          case 40: {
            this_obj.action = "pixelDown";
            callback(null, this_obj);
            break;
          }
          default: {
            break;
          }
        }
      });
    }

    $("#layout_chart_main").off();
    $("#layout_chart_main").on("mousemove touchmove", (event) => {
      event.preventDefault();
      if (coords.down && active) {
        let dx;
        let dy;
        let dx2;
        let dy2;
        let percent;
        if (event.type === "mousemove") {
          dx = event.pageX - coords.mousex;
          dy = event.pageY - coords.mousey;
        } else {
          dx = event.changedTouches[0].pageX - coords.mousex;
          dy = event.changedTouches[0].pageY - coords.mousey;

          /*
                    if (coords.mousex2) {
                        dx2 = event.changedTouches[1].pageX - coords.mousex2;
                        dy2 = event.changedTouches[1].pageY - coords.mousey2;
                        coords.distance2 = distance(event.changedTouches[0].pageX,
                            event.changedTouches[0].pageY,
                            event.changedTouches[1].pageX,
                            event.changedTouches[1].pageY);
                        // $('#log').html(coords.distance2 + ' : ' + coords.distance + '<br>');
                        // $('#log').html(coords.distance2 / coords.distance);
                        percent = (coords.distance2 / coords.distance);
                        pinchScale = scale * percent;
                        zoom_pinch(pinchScale);
                    }
                    */
        }
        let fx = coords.chartx + dx;
        let fy = coords.charty + dy;
        const thisBounds = 400 * scale * scale;
        if (fx < -thisBounds) {
          fx = -thisBounds;
        } else if (fx > thisBounds) {
          fx = thisBounds;
        }
        if (fy < -thisBounds) {
          fy = -thisBounds;
        } else if (fy > thisBounds) {
          fy = thisBounds;
        }
        $("#layout_chart_main").css("left", fx);
        $("#layout_chart_main").css("top", fy);
      }
      if (
        !active &&
        coords.down &&
        (kd.usage === "g_chart" || kd.usage === "x_chart")
      ) {
        const opt = {
          type: "move",
          x: event.pageX,
          y: event.pageY,
        };
        selection(kd, opt, (err, data) => {
          //
        });
      }
    });

    // var touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0]
    $("#layout_chart_main").unbind("mousedown touchstart");
    $("#layout_chart_main").on("mousedown touchstart", (event) => {
      // $('#log').append('touched</br>');
      event.preventDefault();
      if (!active) {
        event.stopPropagation();
      }

      const element = document.querySelector("#layout_chart_main");
      // scale = element.getBoundingClientRect().width / element.offsetWidth;
      const diffx =
        (element.getBoundingClientRect().width - element.offsetWidth) / 2;
      const diffy =
        (element.getBoundingClientRect().height - element.offsetHeight) / 2;
      coords = {
        down: true,
        chartx: $("#layout_chart_main").position().left + diffx,
        charty: $("#layout_chart_main").position().top + diffy,
      };

      if (event.type === "mousedown") {
        coords.mousex = event.pageX;
        coords.mousey = event.pageY;
      } else {
        coords.mousex = parseInt(event.originalEvent.touches[0].pageX, 10);
        coords.mousey = parseInt(event.originalEvent.touches[0].pageY, 10);
        if (event.originalEvent.touches[1]) {
          coords.mousex2 = event.originalEvent.touches[1].pageX;
          coords.mousey2 = event.originalEvent.touches[1].pageY;
          coords.distance = distance(
            coords.mousex,
            coords.mousey,
            coords.mousex2,
            coords.mousey2
          );
        } else {
          coords.mousex2 = null;
          coords.mousey2 = null;
          coords.distance = null;
        }
      }

      if (!active && (kd.usage === "g_chart" || kd.usage === "x_chart")) {
        const opt = {
          type: "start",
          x: coords.mousex,
          y: coords.mousey,
        };

        selection(kd, opt, (err, data) => {
          //
        });
      }
    });

    $("#layout_chart_main").unbind("mouseup touchend");
    $("#layout_chart_main").on("mouseup touchend", (event) => {
      event.preventDefault();
      if (!active && (kd.usage === "g_chart" || kd.usage === "x_chart")) {
        const opt = {
          type: "end",
          x: event.pageX,
          y: event.pageY,
        };

        selection(kd, opt, (err, data) => {
          if (data.length) {
            multiSelect.active = true;
            multiSelect.tables = data;
            kd.emit("chart.update", {});
          } else {
            multiSelect.active = false;
            kd.emit("chart.update", {});
          }
        });
      }
      coords.down = false;
      coords.moved = false;
      scale = pinchScale;
    });

    $("#zoom_in").unbind();
    $("#zoom_in").fastClick((e) => {
      zoom_in();
    });

    $("#zoom_out").unbind();
    $("#zoom_out").fastClick((e) => {
      zoom_out();
    });
  }
  $(".layout_chart_rooms_select_item").off();
  $(".layout_chart_rooms_select_item").fastClick((e) => {
    // if ($('#notification').css('display') === 'none') {
    room(kd, $(`#${e.target.id}`).data("id"));
    // }
  });

  room(kd, kd.localstore.data.room);
};

const distance = (x1, y1, x2, y2) => {
  const a = x1 - x2;
  const b = y1 - y2;
  return Math.sqrt(a * a + b * b);
};

/**
 * Calendar display.
 */

const create = (kd, callback) => {
  kd.localstore.data.room = 1;
  kd.localstore.data.chart_status_filter = 0;

  setActivityInterval(kd, callback);

  /*
    const $section = $('#layout_chart');
    $panzoom = $section.find('.panzoom').panzoom({
        contain: 'invert',
        increment: 0.2,
        minScale: 1,
        maxScale: 2.5,
        cursor: 'default',
        animate: true,
        relative: false,
    });

    $panzoom.parent().on('mousewheel.focal', (e) => {
        e.preventDefault();
        // if (e.originalEvent.deltaY < 0) {
        //    $('#layout_chart_main').css('margin', '-30px 0 0 0');
        // }
        const delta = e.delta || e.originalEvent.wheelDelta;
        const zoomOut = delta ? delta < 0 : e.originalEvent.deltaY > 0;
        $panzoom.panzoom('zoom', zoomOut, {
            increment: 0.2,
            minScale: 1,
            maxScale: 2.5,
            panOnlyWhenZoomed: true,
            animate: true,
            focal: e,
        });
    });

    $panzoom.on('panzoomzoom', () => {
        setTimeout(() => {
            setScale();
        }, 300);
    });

    $panzoom.on('panzoomend', (e, panzoom, matrix, changed) => {
        setScale();
        if ($('#layout_chart_main').offset().top > 50) {
            // $('#layout_chart_main').css('top', 0);
            // TweenMax.to("#layout_chart_main", 1, {y: 0, ease: Power2.easeOut});
            $panzoom.panzoom('resetZoom');
            $panzoom.panzoom('resetPan');
        }
        if (changed) {
            // deal with drags or touch moves
        } else {
            // deal with clicks or taps
            const now = Date.now();
            if (now - tap < 500) {
                if (tap - tap2 < 500) {
                    $panzoom.panzoom('resetZoom');
                    $panzoom.panzoom('resetPan');
                } else {
                    $panzoom.panzoom('zoom', false, {
                        increment: 0.4,
                        minScale: 1,
                        maxScale: 2.5,
                        panOnlyWhenZoomed: true,
                        animate: true,
                        focal: e,
                    });
                }
                tap2 = tap;
            }
            tap = now;
        }
    });
    */

  // $panzoom.panzoom("disable");
  // $panzoom.panzoom("enable");

  kd.on("activity.update", (change) => {
    // maybe take a crc of the chart, update if unchanged, reset if changed.
    // even better would be to update the app after 300 of no additional updates. clear interval
    // on reset
    reset(kd, change, (err, obj) => {
      callback(err, obj);
    });
    setActivityInterval(kd, callback);
  });

  kd.on("location.update", (change) => {
    // maybe take a crc of the chart, update if unchanged, reset if changed.
    location = kd.doc("location")[0];
    kd.templatedata = Object.assign(
      {},
      kd.doc("template", location.template)[0]
    );
    template = kd.templatedata;
    const refresh = { all: false };
    if (change.hasOwnProperty("template")) {
      refresh.all = true;
    }
    reset(kd, refresh, (err, obj) => {
      callback(err, obj);
    });
  });

  kd.on("reservation.update", (change) => {
    reset(kd, { all: false }, (err, obj) => {
      callback(err, obj);
    });
  });

  kd.on("chart.update", () => {
    // maybe take a crc of the chart, update if unchanged, reset if changed.
    // kd.chartdata = Object.assign({}, kd.doc('chart', location.chart)[0]);
    location = kd.doc("location")[0];
    kd.templatedata = Object.assign(
      {},
      kd.doc("template", location.template)[0]
    );
    template = kd.templatedata;
    reset(kd, { all: true }, (err, obj) => {
      callback(err, obj);
    });
  });

  kd.on("template.update", () => {
    location = kd.doc("location")[0];
    if (kd.usage !== "g_section") {
      kd.templatedata = Object.assign(
        {},
        kd.doc("template", location.template)[0]
      );
      template = kd.templatedata;
    }
    reset(kd, { all: false }, (err, obj) => {
      callback(err, obj);
    });
    // kd.emit('chart.update', {});
  });

  kd.on("preSelect", (data) => {
    if (data.hasOwnProperty("active")) {
      preSelect = data;
    } else {
      preSelect = {
        active: false,
      };
    }
    kd.emit("chart.update", {});
  });

  $("#editor_mode_tables, #layout_alt_tables_move").off();
  $("#editor_mode_tables, #layout_alt_tables_move").fastClick(() => {
    disable();
  });

  $("#editor_mode_chart, #layout_alt_tables_chart").off();
  $("#editor_mode_chart, #layout_alt_tables_chart").fastClick(() => {
    enable();
  });

  $("#layout_alt_tables_reset, #layout_alt_tables_resetsave").off();
  $("#layout_alt_tables_reset, #layout_alt_tables_resetsave").fastClick(() => {
    const loc2 = kd.doc("location")[0];
    const chartID = loc2.chart;
    const tablesdata = kd.doc("chart", chartID)[0].tables;
    for (let t = 0; t < tablesdata.length; ++t) {
      if (tablesdata[t].hasOwnProperty("altx")) {
        tablesdata[t].altx = false;
        tablesdata[t].alty = false;
      }
    }
    if (
      kd.location.hasOwnProperty("altTables") &&
      kd.location.altTables &&
      kd.localstore.data.op_state === "standard"
    ) {
      kd.chartdata.tables = tablesdata;
      kd.update({
        _id: loc2._id,
        domain: "location",
        altTables: false,
      })
        .then((result) => {
          return kd.update({
            _id: loc2.chart,
            domain: "chart",
            tables: tablesdata,
          });
        })
        .catch((err4) => {
          console.log("err4", err4);
        });
    }
    conf.vars.localAltTables = "none";
    kd.emit("chart.update", {});
  });

  $("#layout_chart_editor_save, #layout_alt_tables_done").off();
  $("#layout_chart_editor_save, #layout_alt_tables_done").fastClick(() => {
    // TODO: xenial must be updated to work with this first chunk. Add limits to data
    const loc2 = kd.doc("location")[0];
    const chartID = loc.chart;
    const tablesdata = kd.chartdata.tables; // kd.doc('chart', chartID)[0].tables;
    const templates = kd.find("template", {
      $and: [{ active: 1 }, { chart: loc2.chart }],
    });
    const limits = kd.find("limit", { active: 1 });
    if (kd.localstore.data.op_state === "inline") {
      $("#temp_editor_top").css("display", "none");
      $("#temp_editor_sidebar").css("display", "none");
      $("#temp_editor_template").css("display", "none");
      enable();
      $("#layout_alt_tables").css("visibility", "hidden");
      kd.localstore.data.op_state = "standard";
      let altTables = false;
      kd.location.altTables = false;
      conf.vars.localAltTables = "none";
      for (let t = 0; t < tablesdata.length; ++t) {
        if (
          tablesdata[t].hasOwnProperty("altx") &&
          tablesdata[t].altx !== false
        ) {
          conf.vars.localAltTables = "tables";
          kd.location.altTables = true;
          altTables = true;
          break;
        }
      }
      kd.update({
        _id: loc2._id,
        domain: "location",
        altTables,
      });
    }
    const validTables = [];
    let seatCount = 0;
    for (let t = 0; t < tablesdata.length; ++t) {
      if (tablesdata[t].type !== "icon") {
        validTables.push(tablesdata[t].table);
        if (tablesdata[t].seats > 1) {
          seatCount += tablesdata[t].seats;
        }
      }
    }
    if (!loc2.hasOwnProperty("seatCount") || loc2.seatCount !== seatCount) {
      kd.update({
        _id: loc2._id,
        domain: "location",
        seatCount,
      });
    }
    /*
        for (let l = 0; l < limits.length; ++l) {
            if (limits[l].seats !== seatCount) {
                limits[l].seats = seatCount;
                kd.update({
                    _id: limits[l]._id,
                    domain: 'location',
                    seats: seatCount,
                });
            }
        }
        */
    for (let t = 0; t < templates.length; ++t) {
      let removal = false;
      for (let i = templates[t].tables.length - 1; i >= 0; --i) {
        if (!validTables.includes(templates[t].tables[i].table)) {
          templates[t].tables.splice(i, 1);
          removal = true;
        }
      }
      if (removal) {
        kd.update({
          _id: templates[t]._id,
          domain: "template",
          tables: templates[t].tables,
        });
      }
    }
    let removeDisabled = false;
    for (let i = loc2.disabledTables.length - 1; i >= 0; --i) {
      if (!validTables.includes(loc2.disabledTables[i])) {
        loc2.disabledTables.splice(i, 1);
        removeDisabled = true;
      }
    }
    if (removeDisabled) {
      kd.update({
        _id: loc2._id,
        domain: "location",
        disabledTables: loc2.disabledTables,
      });
    }
    if (kd.mode === "guestlist") {
      // location = kd.doc('location')[0];
      const tablearray = kd.chartdata;
      kd.update({
        _id: location.chart,
        domain: "chart",
        tables: tablearray.tables,
      });
      const location_data = Object.assign({}, kd.doc("location")[0]);
      const chart_data = Object.assign(
        {},
        kd.doc("chart", location_data.chart)[0]
      );
      chart_data.tables = Object.assign([], kd.chartdata.tables);
      const limit_data = Object.assign([], kd.doc("limit"));
      const template_data = Object.assign(
        [],
        kd.find("template", {
          $and: [{ active: 1 }, { chart: location_data.chart }],
        })
      );

      const postData = {
        gla: {
          location: location_data,
          chart: chart_data,
          limit: limit_data,
          template: template_data,
        },
      };
      const payload = {
        messageSource: "GL",
        action: "UPDATE",
        payload: postData,
      };
      window.parent.postMessage(payload, "*");
    } else if (kd.mode == "xenial") {
      const location_data = Object.assign({}, kd.doc("location")[0]);
      const chart_data = Object.assign(
        {},
        kd.doc("chart", location_data.chart)[0]
      );
      chart_data.tables = Object.assign([], kd.chartdata.tables);
      const limit_data = Object.assign([], kd.doc("limit"));
      const template_data = Object.assign(
        [],
        kd.find("template", {
          $and: [{ active: 1 }, { chart: location_data.chart }],
        })
      );

      delete location_data.meta;
      delete location_data.$loki;

      delete chart_data._kd.created;
      delete chart_data._kd.updated;
      delete chart_data._kd.confirmed;
      delete chart_data.meta;
      delete chart_data.$loki;

      for (let i = 0; i < template_data.length; ++i) {
        delete template_data[i].meta;
        delete template_data[i].$loki;
        delete template_data[i]._kd.updated;
        template_data[i]._kd.site_id = "embed";
      }

      for (let i = 0; i < limit_data.length; ++i) {
        delete limit_data[i].meta;
        delete limit_data[i].$loki;
      }

      const headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-Company-Id": kd.xenial.companyID,
        Authorization: `Bearer ${kd.xenial.accessToken}`,
      };
      const postData = [
        {
          _id: kd.xenial.config._id,
          name: kd.xenial.config.name,
          gla: {
            location: location_data,
            chart: chart_data,
            limit: limit_data,
            template: template_data,
          },
          entity_id: kd.xenial.config.entity_id,
        },
      ];

      const payload = {
        messageSource: "GL",
        action: "UPDATE",
        payload: postData,
      };
      window.parent.postMessage(payload, "*");

      $.ajax({
        url: `${kd.xenial.dmEnvironmentURL}/floor-plan/entity/\
${kd.xenial.config.entity_id}`,
        type: "POST",
        contentType: "application/json",
        headers,
        data: JSON.stringify(postData),
        success: (result) => {
          console.log("save success");
        },
        error: (jqXHR, textStatus, errorThrown) => {
          console.log(textStatus);
        },
        timeout: 10000,
      });
    }

    const opt = {
      position: "top",
      width: "90%",
      seconds: 1,
      h1: "Seat Map Saved. ",
      body: "",
      buttons: [
        {
          description: "ok",
          value: "close",
        },
      ],
    };
    notification.create(opt, {}, (err, value) => {
      notification.destroy();
    });
  });

  $("#layout_chart_section_save").off();
  $("#layout_chart_section_save").fastClick(() => {
    const templateID = kd.templatedata._id;
    if (kd.mode === "guestlist") {
      const location_data = Object.assign({}, kd.doc("location")[0]);
      kd.update({
        _id: templateID,
        domain: "template",
        _kd: {
          mergerule: "REPLACE",
        },
        chart: location_data.chart,
        tables: Object.assign([], kd.templatedata.tables),
      });
      const chart_data = Object.assign(
        {},
        kd.doc("chart", location_data.chart)[0]
      );
      const limit_data = Object.assign([], kd.doc("limit"));
      const template_data = Object.assign(
        [],
        kd.find("template", {
          $and: [{ active: 1 }, { chart: location_data.chart }],
        })
      );
      for (let t = 0; t < template_data.length; ++t) {
        template_data[t] = Object.assign({}, template_data[t]);
      }

      const postData = {
        gla: {
          location: location_data,
          chart: chart_data,
          limit: limit_data,
          template: template_data,
        },
      };

      const payload = {
        messageSource: "GL",
        action: "UPDATE",
        payload: postData,
      };
      window.parent.postMessage(payload, "*");
    } else if (kd.mode == "xenial") {
      const location_data = Object.assign({}, kd.doc("location")[0]);
      const chart_data = Object.assign(
        {},
        kd.doc("chart", location_data.chart)[0]
      );
      const limit_data = Object.assign([], kd.doc("limit"));
      const template_data = Object.assign(
        [],
        kd.find("template", {
          $and: [{ active: 1 }, { chart: location_data.chart }],
        })
      );
      for (let t = 0; t < template_data.length; ++t) {
        template_data[t] = Object.assign({}, template_data[t]);
      }

      delete location_data.meta;
      delete location_data.$loki;

      delete chart_data._kd.created;
      delete chart_data._kd.updated;
      delete chart_data._kd.confirmed;
      delete chart_data.meta;
      delete chart_data.$loki;

      for (let i = 0; i < template_data.length; ++i) {
        if (template_data[i]._id == templateID) {
          template_data[i].tables = Object.assign([], kd.templatedata.tables);
          kd.templatedata = Object.assign({}, template_data[i]);
        }
        delete template_data[i].meta;
        delete template_data[i].$loki;
        delete template_data[i]._kd.updated;
        template_data[i]._kd.site_id = "embed";
      }

      for (let i = 0; i < limit_data.length; ++i) {
        delete limit_data[i].meta;
        delete limit_data[i].$loki;
      }

      const headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-Company-Id": kd.xenial.companyID,
        Authorization: `Bearer ${kd.xenial.accessToken}`,
      };
      const postData = [
        {
          _id: kd.xenial.config._id,
          name: kd.xenial.config.name,
          gla: {
            location: location_data,
            chart: chart_data,
            limit: limit_data,
            template: template_data,
          },
          entity_id: kd.xenial.config.entity_id,
        },
      ];

      const payload = {
        messageSource: "GL",
        action: "UPDATE",
        payload: postData,
      };
      window.parent.postMessage(payload, "*");

      $.ajax({
        url: `${kd.xenial.dmEnvironmentURL}/floor-plan/entity/\
${kd.xenial.config.entity_id}`,
        type: "POST",
        contentType: "application/json",
        headers,
        data: JSON.stringify(postData),
        success: (result) => {
          console.log("save success");
        },
        error: (jqXHR, textStatus, errorThrown) => {
          console.log(textStatus);
        },
        timeout: 10000,
      });
    }

    const opt = {
      position: "top",
      width: "90%",
      seconds: 1,
      h1: "Template Saved.",
      body: "",
      buttons: [
        {
          description: "ok",
          value: "close",
        },
      ],
    };
    notification.create(opt, {}, (err, value) => {
      notification.destroy();
    });
  });

  reset(kd, { all: true }, (err, obj) => {
    callback(err, obj);
  });
};

const enable = () => {
  active = true;
  $("#editor_mode_tables").removeClass("theme_btn_ocean_highlight");
  $("#editor_mode_chart").addClass("theme_btn_ocean_highlight");
  $("#layout_alt_tables_move").removeClass("theme_btn_ocean_highlight");
  $("#layout_alt_tables_chart").addClass("theme_btn_ocean_highlight");
};

const disable = () => {
  active = false;
  $("#editor_mode_chart").removeClass("theme_btn_ocean_highlight");
  $("#editor_mode_tables").addClass("theme_btn_ocean_highlight");
  $("#layout_alt_tables_chart").removeClass("theme_btn_ocean_highlight");
  $("#layout_alt_tables_move").addClass("theme_btn_ocean_highlight");
};

const resetZoom = () => {
  scale = 1;
  pinchScale = 1;
  zoom_out();
};

const zoom_in = () => {
  scale = scale * 1.2;
  if (scale > 2.5) {
    scale = 2.5;
  }
  pinchScale = scale;
  TweenMax.to("#layout_chart_main", 0, {
    scale,
    ease: Power2.easeOut,
  });
};

const zoom_pinch = (percent) => {
  TweenMax.to("#layout_chart_main", 0, {
    scale: percent,
    ease: Power2.easeOut,
  });
};

const zoom_out = () => {
  if (scale === 1) {
    $("#layout_chart_main").css("left", 0);
    $("#layout_chart_main").css("top", 0);
  }
  scale = scale / 1.2;
  if (scale < 1.1) {
    scale = 1;
  }
  pinchScale = scale;
  TweenMax.to("#layout_chart_main", 0, {
    scale,
    ease: Power2.easeOut,
  });
};

const getBounds = (options) => {
  const b = {
    chart: {
      min: {
        x: 0,
        y: 0,
      },
      max: {
        x: $("#layout_chart_header").width(),
        y: $("#layout_sidebar_standard").height(),
      },
    },
    section: {
      min: {
        x: 1000,
        y: 1000,
      },
      max: {
        x: 0,
        y: 0,
      },
    },
    scale: 0,
    center: {
      x: 0,
      y: 0,
    },
  };

  chart.tables.forEach((table) => {
    if (table.x < b.chart.min.x) {
      b.chart.min.x = table.x;
    }
    if (table.x > b.chart.max.x) {
      b.chart.max.x = table.x;
    }
    if (table.y < b.chart.min.y) {
      b.chart.min.y = table.y;
    }
    if (table.y > b.chart.max.y) {
      b.chart.max.y = table.y;
    }
  });

  if (options) {
    for (let i = 0; i < template.tables.length; ++i) {
      if (template.tables[i].section == options.section) {
        for (let t = 0; t < chart.tables.length; ++t) {
          if (template.tables[i].table == chart.tables[t].table) {
            if (chart.tables[t].x < b.section.min.x) {
              b.section.min.x = chart.tables[t].x;
            }
            if (chart.tables[t].x > b.section.max.x) {
              b.section.max.x = chart.tables[t].x;
            }
            if (chart.tables[t].y < b.section.min.y) {
              b.section.min.y = chart.tables[t].y;
            }
            if (chart.tables[t].y > b.section.max.y) {
              b.section.max.y = chart.tables[t].y;
            }
            break;
          }
        }
      }
    }
  }

  return b;
};

const zoom = (kd, options) => {
  bounds = getBounds(options);

  // bounds.section.min.y = bounds.section.min.y - 50;

  bounds.scale = Math.min(
    bounds.chart.max.x / (bounds.section.max.x - bounds.section.min.x),
    bounds.chart.max.y / (bounds.section.max.y - bounds.section.min.y)
  );

  if (bounds.scale > 2) {
    bounds.scale = 2;
  }
  // bounds.scale = bounds.scale / 1.5;

  bounds.center.x =
    (bounds.section.max.x - bounds.section.min.x) / 2 + bounds.section.min.x;
  bounds.center.y =
    (bounds.section.max.y - bounds.section.min.y) / 2 + bounds.section.min.y;

  // bounds.
  /*
    $panzoom.panzoom('resetZoom', {
        animate: false,
    });

    $panzoom.panzoom('resetPan', {
        contain: 'invert',
        cursor: 'default',
        animate: false,
    });

    $panzoom.panzoom('zoom', false, {
        increment: bounds.scale - 1,
        cursor: 'default',
        panOnlyWhenZoomed: false,
        animate: false,
    });
    */

  // setTimeout(()=>{

  /*
    const xx = -$('#layout_chart_main').offset().left - (bounds.section.min.x * bounds.scale);
                // + ((bounds.chart.max.x - (bounds.section.max.x-bounds.section.min.x))/2);
    const yy = -$('#layout_chart_main').offset().top -
                (bounds.section.min.y * bounds.scale) + 50 * bounds.scale;
                // + ((bounds.chart.max.y - (bounds.section.max.y-bounds.section.min.y))/2);
    */

  scale = 1;

  let xx = ($("#layout_chart_main").width() - 220) / 2 - bounds.center.x;
  let yy = ($("#layout_chart_main").height() - 100) / 2 - bounds.center.y;

  if (xx < -300) {
    xx = -300;
  } else if (xx > 300) {
    xx = 300;
  }
  if (yy < -300) {
    yy = -300;
  } else if (yy > 300) {
    yy = 300;
  }

  $("#layout_chart_main").css("left", xx - 60);
  $("#layout_chart_main").css("top", yy - 100);

  zoom_in();

  roomBySection(kd, options.section);
  // room(kd, 1);
};

const renderTables = (kd, change, callback) => {
  // $('#layout_chart_main').html('');
  conf.vars.max_x = conf.vars.viewportWidth;
  conf.vars.max_y = conf.vars.viewportHeight;
  liveTables = [];
  switch (kd.localstore.data.op_state) {
    case "standard":
    case "inline":
      location = kd.doc("location")[0];
      loc.location = location;
      chart = Object.assign({}, kd.doc("chart", location.chart)[0]);
      template = Object.assign({}, kd.doc("template", location.template)[0]);
      break;
    case "chart":
    case "section":
      chart = kd.chartdata;
      template = kd.templatedata;
      break;
    default:
      break;
  }

  for (let i = 0; i < chart.tables.length; ++i) {
    if (chart.tables[i].room == kd.localstore.data.room) {
      liveTables.push(chart.tables[i].table);
      // get max x and y
      if (chart.tables[i].x > conf.vars.max_x) {
        conf.vars.max_x = chart.tables[i].x;
      }
      if (chart.tables[i].y > conf.vars.max_y) {
        conf.vars.max_y = chart.tables[i].y;
      }
    }
  }

  switch (kd.localstore.data.op_state) {
    case "standard":
    case "section": {
      $("#layout_chart_main").width(conf.vars.max_x);
      $("#layout_chart_main").height(conf.vars.max_y + 100);
      // + (1850 - conf.vars.viewportHeight)); // this might have to adjust based on device
      break;
    }
    case "chart": {
      $("#layout_chart_main").width(1850);
      $("#layout_chart_main").height(1850);
      // + (1850 - conf.vars.viewportHeight)); // this might have to adjust based on device
      break;
    }
    default: {
      break;
    }
  }
  if (
    (change.hasOwnProperty("all") && change.all) ||
    (change.hasOwnProperty("transferredFromTable") &&
      change.transferredFromTable)
  ) {
    // LEFT OFF: maybe just hide the tables on different pages to speed up the build/switch
    $("#layout_chart_main").html("");
    for (let i = 0; i < chart.tables.length; ++i) {
      // if (chart.tables[i].room == kd.localstore.data.room) {
      createTable(kd, chart.tables[i], callback);
      // }
    }
  } else {
    // change for single table.
    // _id is only thing in change object to indicate table. Locate chart table
    const thistable = kd.doc("activity", change._id)[0];
    for (let i = 0; i < chart.tables.length; ++i) {
      if (
        thistable &&
        thistable.hasOwnProperty("table") &&
        chart.tables[i].table === thistable.table
      ) {
        createTable(kd, chart.tables[i], callback);
        if (thistable.hasOwnProperty("join") && thistable.join.length) {
          for (let t = 0; t < thistable.join.length; ++t) {
            for (let j = 0; j < chart.tables.length; ++j) {
              if (chart.tables[j].table === thistable.join[t].table) {
                createTable(kd, chart.tables[j], callback);
              }
            }
          }
        }
      }
    }
  }

  // build room selector
  let resultHTML = "";
  chart.rooms.forEach((roomdata) => {
    if (roomdata.id == kd.localstore.data.room) {
      resultHTML += `<div class="layout_chart_rooms_select_item \
layout_chart_rooms_select_item_highlight" id="room_select${roomdata.id}" \
data-id="${roomdata.id}">${roomdata.name}</div>`;
    } else {
      resultHTML += `<div class="layout_chart_rooms_select_item" \
id="room_select${roomdata.id}" data-id="${roomdata.id}">${roomdata.name}</div>`;
    }
  });

  $("#layout_chart_rooms_select").html(resultHTML);

  for (let i = 0; i < template.tables.length; ++i) {
    // pre mark all tables as section. update() can override based on section in activity doc

    if (
      (kd.localstore.data.op_state == "standard" ||
        kd.localstore.data.op_state == "section") &&
      template.tables[i].section
    ) {
      $(`.table_lib[data-table="${template.tables[i].table}"] > .table_dash > \
                .table_dash_number`).css(
        "color",
        func.getColorByBg(conf.vars.sections[template.tables[i].section].color)
      );
      $(`.table_lib[data-table="${template.tables[i].table}"] > .table_dash > \
                .table_dash_number`).css(
        "background-color",
        conf.vars.sections[template.tables[i].section].color
      );
      if (
        conf.vars.sections[template.tables[i].section].hasOwnProperty("color2")
      ) {
        $(`.table_lib[data-table="${template.tables[i].table}"] > .table_dash > \
                    .table_dash_number`).css(
          "border-left",
          `3px solid ${conf.vars.sections[template.tables[i].section].color2}`
        );
        $(`.table_lib[data-table="${template.tables[i].table}"] > .table_dash > \
                    .table_dash_number`).css(
          "border-right",
          `3px solid ${conf.vars.sections[template.tables[i].section].color2}`
        );
      }
    }
  }

  // read reservations for purposes of table locking

  let nowIndex = timeToIndex(Date.now());
  let baseTurnIndex = Math.round(kd.location.baseTurn / 15);

  reservations = kd.where("reservation", (obj) => {
    if (
      obj.status === 1 &&
      nowIndex >= obj.time - baseTurnIndex &&
      nowIndex <= obj.time
    ) {
      return true;
    }
  });

  lockTables = [];
  reservations.forEach((reservation) => {
    if (
      reservation.hasOwnProperty("preSelect") &&
      reservation.preSelect.length
    ) {
      lockTables = lockTables.concat(reservation.preSelect);
    }
  });

  let nowWait = parseInt(Date.now() / 1000, 10);

  const activitys = kd.where("activity", (obj) => {
    if (
      (obj.status === 1 || obj.status === 2) &&
      obj.hasOwnProperty("preSelect") &&
      obj.preSelect.length
    ) {
      return true;
    }
  });

  lockTablesWait = [];
  activitys.forEach((activity) => {
    if (activity.hasOwnProperty("preSelect") && activity.preSelect.length) {
      lockTablesWait = lockTablesWait.concat(activity.preSelect);
    }
  });

  update(kd, kd.localstore.data.room);
};

const update = (kd, room_num) => {
  // kd.localstore.data.chart_status_filter = 3;

  // attaching activity records to tables
  // assign ids to table divs
  const activitys = kd.doc("activity");
  activitys.forEach((activity) => {
    // set _id data attribute

    if (!activity.hasOwnProperty("section") || activity.section == undefined) {
      activity.section = 0;
    }
    if (
      !activity.hasOwnProperty("size") ||
      activity.size == undefined ||
      !activity.size
    ) {
      activity.size = 2;
    }

    if (parseInt(activity.status, 10) == 3) {
      $(`.table_lib[data-table="${activity.table}"]`).attr(
        "data-id",
        activity._id
      );

      if (kd.localstore.data.op_state == "standard") {
        $("#layout_chart_template_select").css("display", "block");

        if (activity.hasOwnProperty("join") && activity.join.length > 0) {
          // draw line from table to

          activity.join.forEach((joined) => {
            if (liveTables.includes(joined.table)) {
              $(`.table_lib[data-table="${joined.table}"]`).attr(
                "data-id",
                activity._id
              );
              const org = $(
                `.table_lib[data-table="${activity.table}"]`
              ).position();
              const dest = $(
                `.table_lib[data-table="${joined.table}"]`
              ).position();
              $("#layout_chart_main").line(
                org.left / scale + iconSize / 2,
                org.top / scale + iconSize / 2,
                dest.left / scale + iconSize / 2,
                dest.top / scale + iconSize / 2,
                {
                  color: conf.vars.sections[activity.section].color,
                  stroke: 5,
                  zindex: -1,
                },
                `table_lib line_${activity.table}`,
                `line_${activity.table}`,
                getRoomByTable(activity.table)
              );
            }
          });
        }

        if (kd.usage === "embed") {
          $(`.table_lib[data-id="${activity._id}"] > .table_dash > \
                        .table_dash_progress_bg`).css("display", "none");
        } else {
          $(`.table_lib[data-id="${activity._id}"] > .table_dash > \
                        .table_dash_progress_bg`).css("display", "block");
        }

        $(
          `.table_lib[data-id="${activity._id}"] > .table_dash > .table_dash_status`
        ).css("display", "none");

        $(
          `.table_lib[data-id="${activity._id}"] > .table_base > .svg > .table > .top`
        ).css({ fill: "#333333", stroke: "#444444" });

        if (activity.hasOwnProperty("tableStatus")) {
          if (
            activity.tableStatus &&
            location.tableStatus[activity.tableStatus - 1]
          ) {
            $(`.table_lib[data-id="${activity._id}"] > .table_base > .svg > .table > \
                        .top`).css({
              fill: "#333333",
              stroke: location.tableStatus[activity.tableStatus - 1].color,
              "stroke-width": 3,
            });
          }
        }

        if (
          activity.hasOwnProperty("tableName") &&
          activity.tableName.length > 0
        ) {
          $(`.table_lib[data-id="${activity._id}"] > .table_dash > \
                        .table_dash_table_name`).css("display", "inline-block");
          $(`.table_lib[data-id="${activity._id}"] > .table_dash > \
                        .table_dash_table_name`).html(activity.tableName);
          const dashCalc =
            0 -
            ($(`.table_lib[data-id="${activity._id}"] > \
                        .table_dash > .table_dash_table_name`).width() -
              26) /
              2;
          $(`.table_lib[data-id="${activity._id}"] > .table_dash > \
                        .table_dash_table_name`).css(
            "margin-left",
            `${dashCalc}px`
          );
        }

        let sizeIndex = Math.ceil(parseInt(activity.size, 10) / 2) - 1;
        if (sizeIndex > 6) {
          sizeIndex = 6;
        } else if (sizeIndex < 0) {
          sizeIndex = 0;
        }
        const turnTime =
          location.baseTurn * 60 + location.turnTimes[sizeIndex].turnTime * 60;
        const percentStatus3 =
          Math.floor(Date.now() / 1000) - activity.statusTimes.seated;
        let pwidth = Math.round((percentStatus3 / turnTime) * 100);
        if (pwidth > 100) {
          pwidth = 100;
        }
        if (pwidth > 90) {
          $(`.table_lib[data-id="${activity._id}"] > .table_dash > \
                        .table_dash_progress_bg > .table_dash_progress_bar`).css(
            "background-color",
            "#00FF00"
          );
        }
        $(`.table_lib[data-id="${activity._id}"] > .table_dash > .table_dash_progress_bg > \
                    .table_dash_progress_bar`).css("width", `${pwidth}%`);
        if (
          activity.section &&
          conf.vars.sections.hasOwnProperty(activity.section) &&
          conf.vars.sections[activity.section].color
        ) {
          $(
            `.table_lib[data-id="${activity._id}"] > .table_dash > .table_dash_number`
          ).css("background-color", conf.vars.sections[activity.section].color);
        }
        $(
          `.table_lib[data-id="${activity._id}"] > .table_dash > .table_dash_number`
        ).css("border-left", "0");
        $(
          `.table_lib[data-id="${activity._id}"] > .table_dash > .table_dash_number`
        ).css("border-right", "0");

        if (conf.vars.sections[activity.section].color2 !== undefined) {
          $(
            `.table_lib[data-id="${activity._id}"] > .table_dash > .table_dash_number`
          ).css(
            "border-left",
            `3px solid ${conf.vars.sections[activity.section].color2}`
          );
          $(
            `.table_lib[data-id="${activity._id}"] > .table_dash > .table_dash_number`
          ).css(
            "border-right",
            `3px solid ${conf.vars.sections[activity.section].color2}`
          );
        }

        // set seat highlights
        for (let seat = 1; seat <= activity.size; seat++) {
          $(`.table_lib[data-id="${activity._id}"] > .table_base > .svg > .table > \
                        .seat_${seat}`).css({ fill: "#bbbbbb" });
        }
        // tableStatus filter
        if (kd.localstore.data.chart_status_filter == 1) {
          $(`.table_lib[data-id="${activity._id}"]`).css({ opacity: "0.2" });
        } else if (
          kd.localstore.data.chart_status_filter > 1 &&
          kd.localstore.data.chart_status_filter == activity.tableStatus
        ) {
          $(`.table_lib[data-id="${activity._id}"]`).css({ opacity: "1" });
        }
      }
    }
  });

  // check preSelect
  for (let i = 0; i < chart.tables.length; ++i) {
    if (
      preSelect.active &&
      preSelect.reserved.includes(chart.tables[i].table)
    ) {
      $(`.table_lib[data-table="${chart.tables[i].table}"] \
            > .table_base > .svg > .table > .top`).css({ fill: "#aa0000" });
    }
    if (preSelect.active && preSelect.tables.includes(chart.tables[i].table)) {
      $(`.table_lib[data-table="${chart.tables[i].table}"] \
            > .table_base > .svg > .table > .top`).css({ fill: "#ffff84" });
    }
    // reset table locking icons
    $(
      `.table_lib[data-table="${chart.tables[i].table}"] > .table_dash > .table_dash_ribbon`
    ).css("display", "none");
    // reset table wait locking icons
    $(`.table_lib[data-table="${chart.tables[i].table}"] \ 
        > .table_dash > .table_dash_ribbonwait`).css("display", "none");
  }

  // reservation table locking / ribbon display
  lockTables.forEach((table) => {
    if (kd.localstore.data.op_state == "standard") {
      $(
        `.table_lib[data-table="${table}"] > .table_dash > .table_dash_ribbon`
      ).css("display", "block");
    }
  });

  // reservation table locking / ribbon display
  lockTablesWait.forEach((table) => {
    if (kd.localstore.data.op_state == "standard") {
      $(
        `.table_lib[data-table="${table}"] > .table_dash > .table_dash_ribbonwait`
      ).css("display", "block");
    }
  });

  // check multiSelect
  if (multiSelect.active) {
    for (let i = 0; i < multiSelect.tables.length; ++i) {
      $(`.table_lib[data-index="${multiSelect.tables[i].id}"] > .table_base > \
            .svg > .table > .top`).css({
        stroke: "#fcff77",
        "stroke-width": 3,
      });
    }
  }

  // handle disabled tables
  if (kd.localstore.data.chart_status_filter === 0 && !highlight.active) {
    for (let i = 0; i < chart.tables.length; ++i) {
      $(`.table_lib[data-table="${chart.tables[i].table}"]`).css("opacity", 1);
    }
  }
  for (let i = 0; i < location.disabledTables.length; ++i) {
    $(`.table_lib[data-table="${location.disabledTables[i]}"]`).css(
      "opacity",
      0.2
    );
  }
};

const timeToIndex = (time) => {
  let now = moment(time).format("HH:mm").split(":");
  return Math.round((parseInt(now[0], 10) * 60 + parseInt(now[1], 10)) / 15);
};

const setHighlight = (array) => {
  highlight = {
    active: true,
    tables: array,
  };
};

const clearHighlight = () => {
  highlight = {
    active: false,
    tables: [],
  };
  // set tables back to full opacity
  for (let i = 0; i < chart.tables.length; ++i) {
    $(`.table_lib[data-table="${chart.tables[i].table}"]`).css("opacity", 1);
  }
};

const createTable = (kd, data, callback) => {
  // create div holder, append to layout_chart_main
  let zOrder = " z_table";

  if (data.type === "icon") {
    zOrder = " z_icon";
  }
  let thisHTML = `<div class="table_lib${zOrder}" id="table_${data.id}" \
        data-source="standard" data-index="${data.id}" data-type="${data.type}" \
        data-table="${data.table}" data-seat="${data.seats}" data-x="${data.x}" \
        data-y="${data.y}" data-rotation="${data.rotation}" data-disabled="0" \
        data-room="${data.room}">`;
  if (data.type !== "icon") {
    thisHTML +=
      '<div class="table_dash"><div class="table_dash_ribbon">' +
      icons.lib.ribbon +
      "</div>" +
      '<div class="table_dash_ribbonwait">' +
      icons.lib.ribbonwait +
      "</div>" +
      '<div class="table_dash_number"></div>' +
      '<div class="table_dash_progress_bg"><div class="table_dash_progress_bar">' +
      '</div></div><div class="table_dash_status"></div><div class="table_dash_table_name">' +
      "</div></div>";
  }
  const tableType = tables.lib[`${data.type}_${data.seats}`];
  thisHTML += `<div class="table_base">${tableType}</div>`;
  thisHTML += "</div>";
  $(`#table_${data.id}`).remove();
  $(`.line_${data.table}`).remove();
  $("#layout_chart_main").append(thisHTML);
  if (data.type !== "icon") {
    if (isNaN(data.table)) {
      $(`#table_${data.id} > .table_dash > .table_dash_number`).css(
        "font-size",
        "13px"
      );
    } else {
      $(`#table_${data.id} > .table_dash > .table_dash_number`).css(
        "font-size",
        "13px"
      );
    }
    $(`#table_${data.id} > .table_dash > .table_dash_number`).html(data.table);
  } else {
    if (data.seats === 8 && data.hasOwnProperty("scale") && data.scale) {
      TweenMax.to(`#table_${data.id} > .table_base`, 0, {
        scaleX: data.scale,
      });
    } else if (
      data.seats === 13 &&
      data.hasOwnProperty("scaleX") &&
      data.scaleX
    ) {
      TweenMax.to(`#table_${data.id} > .table_base`, 0, {
        scaleX: data.scaleX,
        scaleY: data.scaleY,
      });
    } else if (
      data.seats === 12 &&
      data.hasOwnProperty("label") &&
      data.label
    ) {
      $(`#table_${data.id} > .table_base > .svg > .table > .label`).text(
        data.label
      );
    }
  }
  // custom sizing due to table types here
  TweenMax.to(`#table_${data.id} > .table_base`, 0, {
    rotation: data.rotation,
    ease: Power2.easeOut,
  });
  let tdata = {};
  if (
    ((conf.vars.hasOwnProperty("localAltTables") &&
      conf.vars.localAltTables !== "none") ||
      (kd.location.hasOwnProperty("altTables") && kd.location.altTables)) &&
    data.hasOwnProperty("altx") &&
    data.altx &&
    kd.localstore.data.op_state !== "chart" &&
    kd.localstore.data.op_state !== "section"
  ) {
    tdata = {
      alpha: 1,
      x: data.altx,
      y: data.alty,
      ease: Power2.easeOut,
    };
  } else {
    tdata = {
      alpha: 1,
      x: data.x,
      y: data.y,
      ease: Power2.easeOut,
    };
  }
  TweenMax.to(`#table_${data.id}`, 0, tdata);

  // tableStatus filter
  if (kd.localstore.data.chart_status_filter > 1) {
    $(`#table_${data.id}`).css({ opacity: ".2" });
  }

  // check embed highlights on multi table
  if (embedOverflow.active && embedOverflow.tables.includes(data.table)) {
    $(`#table_${data.id} > .table_base > .svg > .table > .top`).css({
      fill: "#ffff84",
    });
  }

  // check highlight
  if (highlight.active && !highlight.tables.includes(data.table)) {
    $(`#table_${data.id}`).css({ opacity: ".2" });
  }

  // check preSelect

  if (preSelect.active && preSelect.tables.includes(data.table)) {
    $(`#table_${data.id} > .table_base > .svg > .table > .top`).css({
      fill: "#ffff84",
    });
  }
  let down_offset = 0;
  let up_offset = 0;

  if (!(data.type === "icon" && kd.localstore.data.op_state === "standard")) {
    $(`#table_${data.id}`).on("mousedown touchstart", (event) => {
      event.preventDefault();
      if (!active) {
        event.stopPropagation();
      }
      activity_id = $(`#table_${data.id}`).data("id");
      target_id = $(`#table_${data.id}`).attr("id");
      const mouseXPos = $(`#table_${data.id}`).offset().left + 64;
      const mouseYPos = $(`#table_${data.id}`).offset().top + 64;
      down_offset = $(`#table_${data.id}`).offset();
      const this_obj = {
        target_id,
        activity_id,
        id: $(`#table_${data.id}`).data("index"),
        table: $(`#table_${data.id}`).data("table"),
        action: "down",
        disabled: isDisabled(kd, $(`#${data.id}`).data("table")),
        source: $(`#table_${data.id}`).data("source"),
        type: $(`#table_${data.id}`).data("type"),
        seat: $(`#table_${data.id}`).data("seat"),
        multiSelect,
        mouseXPos,
        mouseYPos,
      };
      callback(null, this_obj);
    });

    $(`#table_${data.id}`).on("mouseup touchend", (event) => {
      event.preventDefault();
      if (!active) {
        event.stopPropagation();
      }
      activity_id = $(`#table_${data.id}`).data("id");
      target_id = $(`#table_${data.id}`).attr("id");
      up_offset = $(`#table_${data.id}`).offset();
      let action = "drag";
      if (kd.localstore.data.op_state !== "chart") {
        if (
          Math.abs(up_offset.left - down_offset.left) < 15 &&
          Math.abs(up_offset.top - down_offset.top) < 15
        ) {
          action = "up";
        }
      } else {
        if (
          Math.abs(up_offset.left - down_offset.left) < 1 &&
          Math.abs(up_offset.top - down_offset.top) < 1
        ) {
          action = "up";
        }
      }
      const this_obj = {
        target_id,
        activity_id,
        id: $(`#table_${data.id}`).data("index"),
        table: $(`#table_${data.id}`).data("table"),
        action,
        disabled: isDisabled(kd, $(`#${data.id}`).data("table")),
        source: $(`#table_${data.id}`).data("source"),
        type: $(`#table_${data.id}`).data("type"),
        seat: $(`#table_${data.id}`).data("seat"),
        multiSelect,
      };
      callback(null, this_obj);
    });
  }
};

const getMultiSelect = () => {
  return multiSelect;
};

module.exports = {
  chart,
  getActive,
  zoom,
  enable,
  resetZoom,
  disable,
  iconSize,
  create,
  reset,
  update,
  setHighlight,
  clearHighlight,
  getScale,
  getTurnTime,
  renderTables,
  room,
  roomBySection,
  roomByTable,
  setEmbedOverflow,
  getEmbedOverflow,
  addEmbedOverflow,
  getMultiSelect,
};



/** WEBPACK FOOTER **
 ** ./src/components/chart/index.js
 **/